import React from 'react'
import _map from 'lodash/map'
import _filter from 'lodash/filter'
import { getTicketTypeIcon } from '../utils/ticketTypeIcons'
import { getTicketTypeGroupAndName } from '../utils/stringUtils'

const SeatLabelMin = (props) => {
  const {
    top,
    left,
    tierId,
    ticketTypeTireRelationsArray = [],
    tierPrices = {}
  } = props

  const visibleTickets = _filter(ticketTypeTireRelationsArray, {
    ticket_type_tier_id: tierId
  })
  const { ticketTypeGroupName } = visibleTickets[0]
    ? getTicketTypeGroupAndName(visibleTickets[0].ticket_type_name)
    : {}

  return (
    <div className='seatLabelContainer' style={{ top, left }}>
      <div className='seatLabelRect seatLabelRect-ppp'>
        <div className='seatLabelHeader seatLabelHeader-ppp'>
          {getTicketTypeIcon(undefined, ticketTypeGroupName)}
          <span>{(ticketTypeGroupName || '').toUpperCase()}</span>
        </div>
        <div className='seatLabelContent seatLabelContent-ppp'>
          <div className='seatLabelRow'>
            <div className='seatLabelItem'>
              <div className='seatLabelItemTitle'>TABLE</div>
              {_map(visibleTickets, (item) => {
                const { ticketTypeName } = getTicketTypeGroupAndName(
                  item.ticket_type_name
                )
                return (
                  <div key={item.ticket_type_id} className='seatLabelItemText'>
                    {(ticketTypeName || '').toUpperCase()}
                  </div>
                )
              })}
            </div>
            <div className='seatLabelItem'>
              <div className='seatLabelItemTitle'>PRICE</div>
              {_map(visibleTickets, (item) => {
                return (
                  <div key={item.ticket_type_id} className='seatLabelItemText'>
                    {tierPrices[item.ticket_type_tier_id]}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
      <div className='seatLabelTriangle seatLabelTriangle-ppp' />
    </div>
  )
}

export { SeatLabelMin }
